import React, { useState } from "react";
import Editor from "@monaco-editor/react";
import { useContext } from "react";
import { JSONataEditorContext } from "../contexts/JSONataEditorContext";

export default function JsonEditor() {

    const { value, setValue } = useContext(JSONataEditorContext)
    return (
        <Editor
            defaultLanguage="json"
            theme="vs-light"
            value={value}
            options={{
                readOnly:"true",
                lineNumbers: "off",
                minimap:{enabled:false}
            }}
            onChange={(newValue) => { setValue(newValue) }}
        />
    );
}

